import { jsxs as r } from "react/jsx-runtime";
import e from "./index.es5548.js";
import { FooterButtonGroup as m } from "./index.es5549.js";
import { FooterRightControls as n } from "./index.es5550.js";
import { FooterLeftControls as i } from "./index.es5551.js";
const o = ({ children: t }) => /* @__PURE__ */ r("div", { className: e.root, children: [
  " ",
  t
] });
o.ButtonGroup = m;
o.RightControls = n;
o.LeftControls = i;
export {
  o as SectionMenuFooter
};
//# sourceMappingURL=index.es5547.js.map
